import { render, staticRenderFns } from "./SoliLocation.vue?vue&type=template&id=2aedc35a"
import script from "./SoliLocation.vue?vue&type=script&lang=js"
export * from "./SoliLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports